import React, { useEffect, useState } from 'react';

/**
 * A google.maps.Circle rendered as a child of GoogleMap.
 *
 * Mirrors Marker.jsx: the parent clones its children with `map` injected, so `options` here are
 * whatever google.maps.CircleOptions accepts (center, radius, strokeColor, fillOpacity, ...).
 */
function Circle({ forwarded, map, ...options }) {
    const [circle, setCircle] = useState();

    useEffect(() => {
        if (!circle) {
            const ref = new window.google.maps.Circle();

            if (forwarded) {
                forwarded.current = ref;
            }

            setCircle(ref);
        }

        return () => {
            if (circle) {
                circle.setMap(null);
            }
        };
    }, [circle]);

    // `options` is a fresh object on every render, so keying the effect on its identity would
    // re-push identical geometry every time the parent re-renders — on the tracking map that is
    // once per driver coordinate the subscription pushes. `optionsKey` is the dependency instead,
    // the same way the parent compares `bounds`; `options` itself is read but deliberately not a
    // dependency. `map` is held out of the key because it is a live Maps instance, not JSON.
    const optionsKey = JSON.stringify(options);

    useEffect(() => {
        if (circle) {
            circle.setOptions({ ...options, map });
        }
    }, [circle, map, optionsKey]);

    return null;
}

export default React.forwardRef((props, ref) => {
    return <Circle {...props} forwarded={ref} />;
});
